import { render, staticRenderFns } from "./DataIndicatorKanban.vue?vue&type=template&id=daaf8896&scoped=true&"
import script from "./DataIndicatorKanban.vue?vue&type=script&lang=js&"
export * from "./DataIndicatorKanban.vue?vue&type=script&lang=js&"
import style0 from "./DataIndicatorKanban.vue?vue&type=style&index=0&id=daaf8896&lang=stylus&scoped=true&"
import style1 from "./DataIndicatorKanban.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaf8896",
  null
  
)

export default component.exports